<template>
  <div
    class="ttshop_user"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <div class="ttshop_orderxq">
          <!-- 面包屑 -->
          <div class="ttshop_ordernav clearfloat">
            <p class="ttshop_navtext" @click="goTtshop_user">个人中心</p>
            <span>&gt;</span>
            <p class="ttshop_navtext" @click="goTtshop_usermyorder">订单中心</p>
            <span>&gt;</span>
            <p class="ttshop_orderdh">
              订单：<strong>{{ order_id }}</strong>
            </p>
          </div>

          <!-- 评价 -->
          <div class="ttshop_evaluate">
            <!-- 店铺评价 -->
            <div class="ttshop_evaluateup" v-if="type != 'IN'">
              <ul class="clearfloat">
                <li class="clearfloat">
                  <span>描述/包装</span>
                  <div class="ttshop_evaluatenum">
                    <el-rate v-model="mch_score[0]"></el-rate>
                  </div>
                </li>
                <li class="clearfloat">
                  <span>物流服务/配送</span>
                  <div class="ttshop_evaluatenum">
                    <el-rate v-model="mch_score[1]"></el-rate>
                  </div>
                </li>
                <li class="clearfloat">
                  <span>服务态度/质量</span>
                  <div class="ttshop_evaluatenum">
                    <el-rate v-model="mch_score[2]"></el-rate>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 店铺商品评价 -->
            <div class="ttshop_evaluatebut">
              <div
                class="ttshop_evaluatebutlist"
                v-for="(item, index) in goods_list"
                :key="index"
              >
                <div class="ttshop_evaluateshop clearfloat">
                  <div class="ttshop_evaluateshopimg">
                    <img class="img-default" :src="item.goods_pic" alt="" />
                  </div>
                  <div class="ttshop_evaluateshoptext">
                    <h5>{{ item.name }}</h5>
                    <!-- <span v-for="(attr,ids) in items.attr_list" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span> -->
                  </div>
                </div>
                <div class="ttshop_evaluatecon clearfloat">
                  <span>评分</span>
                  <div class="ttshop_evaluatenum">
                    <el-rate
                      @change="selectShopstar(index)"
                      v-model="item.star"
                    ></el-rate>
                  </div>
                </div>
                <div class="ttshop_evaluatecon clearfloat">
                  <span>评价</span>
                  <div class="ttshop_evaluatenum">
                    <textarea
                      v-model="item.content"
                      placeholder="请填写您的商品的评价..."
                    ></textarea>
                  </div>
                </div>
                <div class="ttshop_evaluatecon clearfloat">
                  <span>晒图</span>
                  <div class="ttshop_barterbutupimg">
                    <el-upload
                      action="String"
                      :on-change="
                        (file, fileList) => {
                          handleChange(file, fileList, index);
                        }
                      "
                      :on-remove="
                        (file, fileList) => {
                          handleRemove(file, fileList, index);
                        }
                      "
                      list-type="picture-card"
                      :auto-upload="false"
                      accept="image/*"
                      :limit="imgLimit"
                      :file-list="productImgs"
                      :multiple="isMultiple"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      :on-exceed="handleExceed"
                      :on-error="imgUploadError"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        class="img-default"
                        width="100%"
                        :src="dialogImageUrl"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div>
              </div>
            </div>
            <div class="ttshop_evaluatesub clearfloat">
              <button @click="submit">提交</button>
              <!-- <button>取消</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
export default {
  components: {
    Header,
    Userheader,
    Foot,
  },
  data() {
    return {
      mch_score: [5, 5, 5],
      value: null,
      value1: null,
      value2: null,
      dialogImageUrl: "",
      dialogVisible: false,
      productImgs: [],
      isMultiple: true,
      imgLimit: 5,
      id: this.$route.query.id,
      type: this.$route.query.type,
      goods_list: [],
      content: "",
      loading: false,
      order_id: "",
    };
  },
  mounted() {
    this.commentPreview();
  },
  methods: {
    //去个人中心
    goTtshop_user() {
      this.$router.replace("/ttshop_user");
    },
    //去列表
    goTtshop_usermyorder() {
      this.$router.replace("/ttshop_usermyorder");
    },
    handleAvatarSuccess(res, file) {
      //图片上传成功
      console.log(res);
      console.log(file);
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleExceed(files, fileList) {
      //图片上传超过数量限制
      this.$message.error("上传图片不能超过5张!");
    },
    imgUploadError(err, file, fileList) {
      //图片上传失败调用
      this.$message.error("上传图片失败!");
    },
    // 选择图片
    handleChange(file, fileList, index) {
      this.goods_list[index].uploaded_pic_list = fileList;
    },
    handleRemove(file, fileList, index) {
      //移除图片
      this.goods_list[index].uploaded_pic_list = fileList;
    },
    // 获取数据
    commentPreview() {
      let params = {
        order_id: this.id,
      };
      if (this.type == "IN") {
        params.type = "IN";
      } else {
        params.type = "mall";
      }
      this.$api
        .comment_preview(params)
        .then((res) => {
          console.log(res);
          for (let i in res.data.goods_list) {
            res.data.goods_list[i].pic_list = [];
            res.data.goods_list[i].uploaded_pic_list = [];
            res.data.goods_list[i].score = 3;
            res.data.goods_list[i].score_star = 5;
            res.data.goods_list[i].content = "";
            res.data.goods_list[i].star = 5;
          }
          this.goods_list = res.data.goods_list;
          this.order_id = res.data.order_id;
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    // 商品评价星星
    selectShopstar(index) {
      let goods_list = this.goods_list;
      let score = 0;
      console.log(index);
      if (goods_list[index].star < 3) {
        score = 1;
      } else if (goods_list[index].star > 3) {
        score = 3;
      } else {
        score = 2;
      }
      goods_list[index].score = score;
      goods_list[index].score_star = goods_list[index].star;
      this.goods_list = goods_list;
      console.log(this.goods_list);
    },
    beforeAvatarUpload(file) {
      //文件上传之前调用做一些拦截限制
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 提交按钮
    async submit() {
      let _this = this;
      _this.loading = true;
      let goods_list = _this.goods_list;
      // 内容判断
      for (let i in goods_list) {
        if (goods_list[i].score_star <= 3) {
          if (!goods_list[i].content) {
            _this.loading = false;
            let err = {
              msg: "商品评价不能为空",
            };
            this.common.message(this, err);
            return false;
          }
        } else {
          if (!goods_list[i].content) {
            goods_list[i].content = "默认好评";
          }
        }
      }
      // 图片判断
      for (let i in goods_list) {
        if (goods_list[i].uploaded_pic_list.length > 0) {
          let urlArr = [];
          for (let j in goods_list[i].uploaded_pic_list) {
            const formData = new FormData();
            formData.append("image", goods_list[i].uploaded_pic_list[j].raw);
            let config = {
              headers: {
                "Content-Type": "mutipart/form-data",
              },
            };
            let res = await _this.$api.uploadImage(formData, config);
            if (res.code == 0) {
              urlArr.push(res.data.url);
            } else {
              console.log(res);
            }
            // 之前的写法，有可能在后续的转换json字符串的goog_list数组中uploaded_pic_list为空
            // _this.$api
            //   .uploadImage(formData, config)
            //   .then((res) => {
            //     console.log(res);
            //     // this.imageUrl = res.data.url;
            //     urlArr.push(res.data.url);
            //   })
            //   .catch((err) => {
            //     console.log(err);
            //   });
          }
          goods_list[i].uploaded_pic_list = urlArr;
          _this.goods_list = goods_list;
        }
      }
      console.log(_this.goods_list);
      _this.postComment();
    },

    // 提交接口
    postComment() {
      let _this = this;
      let goods_list = _this.goods_list;
      let mch_score = _this.mch_score;
      let params = {
        order_id: _this.id,
        goods_list: JSON.stringify(goods_list),
      };
      if (this.type == "IN") {
        params.type = "IN";
      } else {
        params.type = "mall";
        params.mch_describe = mch_score[0];
        params.mch_logistics = mch_score[1];
        params.mch_service = mch_score[2];
      }
      _this.$api
        .comment(params)
        .then((res) => {
          console.log(res);
          _this.loading = false;
          _this.$message({
            type: "success",
            message: res.msg,
            showClose: true,
            offset: 200,
            duration: 1000,
          });
          setTimeout(function () {
            _this.$router.go(-1);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          this.common.message(this, err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.ttshop_orderxq {
  width: 100%;

  .ttshop_ordernav {
    width: 100%;
    margin-bottom: 20px;

    .ttshop_navtext {
      float: left;
      cursor: pointer;
      font-size: 12px;
      color: #333;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;

      &:hover {
        color: #ff0e25;
      }
    }

    span {
      float: left;
      font-size: 12px;
      color: #333;
      margin: 0 5px;
    }

    .ttshop_orderdh {
      float: left;
      font-size: 12px;
      color: #333;

      strong {
        font-size: 12px;
        color: #333;
        font-weight: 400;
      }
    }
  }

  .ttshop_evaluate {
    width: 100%;
    padding: 30px 40px;
    background: #fff;
    box-sizing: border-box;

    .ttshop_evaluateup {
      width: 100%;
      margin-bottom: 40px;

      ul {
        li {
          float: left;
          margin-right: 80px;

          &:last-child {
            margin-right: 0;
          }

          span {
            float: left;
            font-size: 14px;
            color: #666;
            margin-right: 24px;
            line-height: 24px;
          }

          .ttshop_evaluatenum {
            float: left;
          }
        }
      }
    }

    .ttshop_evaluatebut {
      width: 100%;

      .ttshop_evaluatebutlist {
        width: 100%;
        padding: 40px 0;
        border-bottom: 1px solid #ebebeb;
        box-sizing: border-box;

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          border-bottom: 0;
        }

        .ttshop_evaluateshop {
          width: 100%;
          margin-bottom: 32px;

          .ttshop_evaluateshopimg {
            float: left;
            width: 80px;
            height: 80px;
            margin-right: 12px;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .ttshop_evaluateshoptext {
            float: left;
            max-width: 400px;

            h5 {
              font-size: 12px;
              color: #333;
              font-weight: 400;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              line-height: 18px;
              margin-bottom: 10px;
            }

            span {
              font-size: 12px;
              color: #999;
              margin-right: 10px;

              strong {
                font-size: 12px;
                color: #999;
                font-weight: 500;
              }
            }
          }
        }

        .ttshop_evaluatecon {
          width: 100%;
          margin-bottom: 32px;

          &:last-child {
            margin-bottom: 0;
          }

          &:last-child span {
            line-height: 60px;
          }

          span {
            float: left;
            font-size: 14px;
            color: #666;
            margin-right: 24px;
            line-height: 24px;
          }

          .ttshop_evaluatenum {
            float: left;

            textarea {
              width: 616px;
              height: 112px;
              border: 1px solid #ebebeb;
              border-radius: 2px;
              resize: none;
              outline: none;
              font-size: 12px;
              color: #333;
              padding: 15px;
              box-sizing: border-box;
            }
          }

          .ttshop_barterbutupimg {
            overflow: hidden;
            float: left;
          }
        }
      }
    }

    .ttshop_evaluatesub {
      width: 100%;
      padding-top: 20px;
      padding-bottom: 60px;
      box-sizing: border-box;

      button {
        float: left;
        width: 102px;
        height: 24px;
        font-size: 12px;
        color: #666;
        border: 1px solid #ebebeb;
        margin-right: 12px;
        outline: none;
        box-sizing: border-box;
        background: transparent;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        cursor: pointer;

        &:first-child {
          background: #ff0e25;
          color: #fff;
          border-color: #ff0e25;
        }

        &:first-child:hover {
          box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
        }

        &:last-child:hover {
          background: #ff0e25;
          color: #fff;
          border-color: #ff0e25;
          box-shadow: 0 0 10px rgba(255, 14, 37, 0.3);
        }
      }
    }
  }
}
</style>
